// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"TabBarOverviewMenu_tabContainer__o8gx6","line":"TabBarOverviewMenu_line__ioU-o","btnContainer":"TabBarOverviewMenu_btnContainer__2k-Sr"};